// extracted by mini-css-extract-plugin
export default {"rating":"OF-z","numberOfStars":"PF-z","count":"QF-z","barGraphSpacing":"RF-z","barGraph":"SF-z"};